import { DateFormat } from 'components/DateFormat';
import { Users } from 'models/UserCollection';
import { Request } from "components/Request";
import { ChatActions } from 'components/ChatActions';
import { MatchSounds } from 'components/MatchSounds';
import { LadderLinker } from 'components/LadderLinker';
import { BrowserNotification } from 'components/BrowserNotification';
import { Dashboard } from 'components/Dashboard';
import { PingAverage } from './PingAverage';
import { SiteNotification } from './SiteNotification';
import { privateChatMessageHolder } from 'components/PrivateChatMessageHolder';
import { ChatMessageNotification } from 'models/ChatMessage';
import { ChatRoom } from 'models/ChatRoom';
import { matchSearchListManager } from 'components/MatchSearchListManager';
import applyCurrentMatches from 'components/applyCurrentMatches';
import applyChatRooms from 'components/applyChatRooms';
import applyEmailValidated from 'components/applyEmailValidated';
import applyAutoQueueMatchUpdate from 'components/applyAutoQueueMatchUpdate';
import { publishRecordedGame } from 'slippi/friendlies/recordedGameMessages';
import { publishModeratedMatchChat } from 'react/matchPage/moderatedMatchChatMessages';
import getRandomInt from 'functions/getRandomInt';
import Bug from 'models/Bug';

import { LadderTime } from 'components/LadderTime';

import * as featuredStreamsActions from 'react/redux/actions/featuredStreams';
import * as subHypeActions from 'react/redux/actions/subHype';
import * as disputeActions from 'react/redux/actions/disputes';
import * as matchmakingActions from 'react/redux/actions/matchmaking';
import * as userActions from 'react/redux/actions/user';
import { doublesPartyReceived } from 'react/redux/actions/doublesParty';
import * as privateChatActions from 'react/redux/actions/privateChat';
import * as notificationActions from 'react/redux/actions/notifications';
import directMessagePushes from 'react/notifications/directMessagePushes';
import { directMessageRead } from 'react/redux/actions/directMessageRead';
import receiveRankChange from 'react/matchResult/receiveRankChange';

import store from 'react/redux/store/store';
import { CacheableDataObject } from 'models/CacheableDataObject';
import RpgMessage from './RpgMessage';
import { setHeaderCount } from 'react/layout/header/siteHeaderState';
import moment from "moment";
import { isNetplayPageActive } from 'react/netplay/netplayPageState';
import { assignPage, openPage } from 'navigation/pageLocation';

class ServerMessageController {
	ladder_error_banned(response) {
		var url = window.location.href;

		var lastSegment = url.split('/').pop();
		if(lastSegment === 'netplay') {
			assignPage(siteUrl);
		}
	}

	greatest_subs(response) {
		store.dispatch(subHypeActions.greatestSubsUpdate(response.greatest_subs));
	}

	dispute_destroyers(response) {
		if(response.dispute_destroyers) {
			store.dispatch(subHypeActions.mostDisputes(response.dispute_destroyers));
		}
	}

	site_notification(response) {
		const notification = response.site_notification;
		if(notification.active) {

			SiteNotification.setNotification(notification);
		}
		else {
			SiteNotification.removeNotification();
		}
	}

	slippi_game_recorded(response) {
		publishRecordedGame(response.slippi_game_recorded);
	}

	emotes(response) {
		LadderLinker.emoteShortcuts = response.emotes;
	}

	chatlinks(response) {
		LadderLinker.autoReplaces = response.chatlinks;
	}

	search_notifications(response) {
		if(response.search_notifications) {
			let searchNotifications = response.search_notifications;
			myUser.getSearchNotifications().updateAll(searchNotifications);
		}
	}

	preferred_games(response) {
		if(response.preferred_games) {
			Dashboard.updatePreferredGames(response.preferred_games);
		}
	}

	no_match(response) {
		if(response.no_match) {
			for(let id of response.no_match) {
				const player = Users.findById(id);
				if(player) {
					player.active_match_id = null;
				}
			}
		}
	}

	chat_motd_update(response) {
		const data = response.chat_motd_update;

		const chatRoomData = {
			id: data.chat_room_id,
			description: data.motd,
			description_id: data.description_id,
		};
		const chatRoom = ChatRoom.updateAndRetrieveChatRoom(chatRoomData, false);
		console.log(chatRoom, chatRoomData);
		if(chatRoom) {
			chatRoom.descriptionReset();
		}

	}

	ping(response) {
		if(response.ping > 1) {
			LadderTime.sentRequest().gotServerTimestamp(response.ping);
		}
	}

	my_user(response) {
		myUser.update(response.my_user);
		if(response.my_user.friends) {
			store.dispatch(privateChatActions.friendListUpdated());
		}
	}

	auto_queue_match_update(response) {
		applyAutoQueueMatchUpdate(response.auto_queue_match_update, {
			findMatchById: (matchId) => matchSearchListManager.findMatchById(matchId),
			dispatch: store.dispatch,
		});
	}

	// Both members of a ranked 2v2 party get it on every change, including
	// declined and ended (reducers/doublesParty).
	doubles_party(response) {
		store.dispatch(doublesPartyReceived(response.doubles_party));
	}

	friend_requests(response) {
		if(response.friend_requests.new) {
			$.each(response.friend_requests.new, function(id, friendRequest) {
				if(!Dashboard.pendingFriendRequests[id]) {
					friendRequest = Users.update(friendRequest);
					BrowserNotification.showNotification(
						'Friend Request!',
						{
							body: friendRequest.username + ' wants to be friends!',
							icon: friendRequest.selected_flair.fullUrl,
						}
					);

					const chatNotification = ChatMessageNotification.create();
					chatNotification.type = ChatMessageNotification.types.FRIEND_REQUEST;
					chatNotification.player = friendRequest;

					ChatActions.addNotificationToChat(null, chatNotification);
					Dashboard.pendingFriendRequests[id] = true;
				}

			});
		}
		if(response.friend_requests.accepted) {
			var friend = Users.update(response.friend_requests.accepted.player);
			const chatNotification = ChatMessageNotification.create();
			chatNotification.type = ChatMessageNotification.types.FRIEND_REQUEST_ACCEPTED;
			chatNotification.player = friend;
			BrowserNotification.showNotification(
				'New Friend!',
				{
					body: friend.username + ' accepted your friend request!',
				}
			);

			ChatActions.addNotificationToChat(null, chatNotification);
		}
	}

	current_matches(response) {
		applyCurrentMatches(response.current_matches, { manager: matchSearchListManager, matchmakingDisabled });
	}

	searches(response) {
		if(matchmakingDisabled || !isNetplayPageActive()) {
			return;
		}
		const hadReferences = CacheableDataObject.parseReferences(response.searches);
		matchSearchListManager.parseSearches(response.searches);
	}

	open_challenges(response) {
		if(matchmakingDisabled || !isNetplayPageActive()) {
			return;
		}
		matchSearchListManager.parseSearches(response.open_challenges);
	}

	awaiting_replies(response) {
		if(matchmakingDisabled || !isNetplayPageActive()) {
			return;
		}
		matchSearchListManager.parseSearches(response.awaiting_replies);
	}

	friend_online(response) {
		_.each(response.friend_online, function(friend) {
			friend = Users.update(friend);

			store.dispatch(privateChatActions.friendListUpdated());
			if(friend.isOnline()) {
				friend.showOnlineNotification();
			}
			// else {
			// 	friend.showOfflineNotification();
			// }
		});
	}
}

ServerMessageController.prototype.authentication = ServerMessageController.success;

ServerMessageController.prototype.disputed_matches = function(response) {
	store.dispatch(disputeActions.disputeListUpdated(response.disputed_matches));
};
ServerMessageController.prototype.email_validated = function(response) {
	applyEmailValidated(response.email_validated, {
		user: window.myUser,
		notifyStore: () => store.dispatch(userActions.updatedMyUser()),
		target: window,
	});
};
// A new bell feed item: {item, unread_count}. Achievements also toast.
ServerMessageController.prototype.notification = function(response) {
	if(response.notification && response.notification.item) {
		store.dispatch(notificationActions.receivedNotificationPush(response.notification));
	}
};

// Bell items another action read ({ids, unread_count}): reading a room reads its mentions.
ServerMessageController.prototype.notifications_read = function(response) {
	store.dispatch(notificationActions.receivedNotificationsRead(response.notifications_read));
};
// Bell items the server deleted ({ids, unread_count}): a deleted message's mentions.
ServerMessageController.prototype.notifications_removed = function(response) {
	store.dispatch(notificationActions.receivedNotificationsRemoved(response.notifications_removed));
};

ServerMessageController.prototype.sub_hype = function(response) {
	if(!isNetplayPageActive()) {
		return;
	}
	console.log('the sub');

	store.dispatch(subHypeActions.showSubHype(response.sub_hype));
};
ServerMessageController.prototype.rank_change = function(response) {
	receiveRankChange(response.rank_change);
};
ServerMessageController.prototype.bug_notifications = function(response) {
	setHeaderCount('bugs', response.bug_notifications.count);
};
ServerMessageController.prototype.flagged_matches = function(response) {
	setHeaderCount('flaggedMatches', response.flagged_matches.count);
};
ServerMessageController.prototype.match_help_requests = function(response) {
	setHeaderCount('matchHelpRequests', response.match_help_requests.count);
};
// A message in a match chat the mod joined; mods aren't lobby members.
ServerMessageController.prototype.moderated_match_chat = function(response) {
	publishModeratedMatchChat(response.moderated_match_chat);
};
ServerMessageController.prototype.featured_streams = function(response) {
	store.dispatch(featuredStreamsActions.featuredStreamsUpdate(response.featured_streams));
};
ServerMessageController.prototype.mod_ban_notification = function(response) {
	var notification = response.mod_ban_notification;
	setHeaderCount('banAppeals', notification.count);
	if(notification.is_new) {
		var notificationUser = Users.update(notification.bug.submitter);
		BrowserNotification.showNotification(notificationUser.username + ' Ban Discussion',
			{
				body: notification.bug.description,
				icon: siteUrl + '/images/random/BibleThump.jpg',
				onClick: function() {
					openPage(notification.bug.url);
				}
			});

		const chatNotification = ChatMessageNotification.create();
		chatNotification.type = ChatMessageNotification.types.MOD_NOTIFICATION;
		chatNotification.player = notificationUser;
		chatNotification.title = ` (Ban Discussion - FIXED) `;
		const lengthOfDescription = 70;

		chatNotification.summary = notification.bug.description.length > lengthOfDescription ? notification.bug.description.substring(0, lengthOfDescription) + '...' : notification.bug.description;
		chatNotification.url = notification.bug.url;

		ChatRoom.addMessageToActiveChatRoom(chatNotification);
	}
};

ServerMessageController.prototype.mod_notifications = function(response) {
	var notification = response.mod_notifications;
	setHeaderCount('modNotifications', notification.count);

	const bug = Bug.create(notification.bug);
	if(notification.is_new) {
		BrowserNotification.showNotification(notification.bug.title + ' Mod Notification',
			{
				body: notification.bug.description,
				icon: siteUrl + '/images/random/BibleThump.jpg',
				onClick: function() {
					openPage(notification.bug.url);
				}
			});
		const notificationTitle = ' (Report To Mods) ' + bug.title + ' ';
		const chatNotification = ChatMessageNotification.create();
		chatNotification.type = ChatMessageNotification.types.MOD_NOTIFICATION;
		chatNotification.player = bug.submitter;
		chatNotification.title = notificationTitle;
		chatNotification.summary = bug.description;
		chatNotification.url = bug.url;

		ChatRoom.addMessageToActiveChatRoom(chatNotification);

		MatchSounds.playModNotification();
	}
	else {
		if(notification.bug) {
			if(!bug.modified_by) {
				bug.modified_by = {};
			}
			if(bug.fixed) {
				BrowserNotification.showNotification(bug.title,
					{
						body: 'Marked resolved by ' + bug.modified_by.username
					}
				);
			}
			else {
				BrowserNotification.showNotification('Reopened Notification from ' + bug.submitter.username + ': ' + bug.title,
					{ body: 'Opened by ' + bug.modified_by.username });
			}
		}

	}
};
ServerMessageController.prototype.kicked_from_chat = function(response) {
	console.error('reimplement kicked from chat');
	console.log(response.kicked_from_chat.id);
};
ServerMessageController.prototype.chat_room_closed = function(response) {
	ChatRoom.closeFromServer(response.chat_room_closed.id);
};
ServerMessageController.prototype.chat_room_colors_update = function(response) {
	const { chat_room_id: chatRoomId, colors } = response.chat_room_colors_update;
	ChatRoom.applyColorsFromServer(chatRoomId, colors);
};
ServerMessageController.prototype.chat_room_mute = function(response) {
	const { chat_room_id: chatRoomId, mute } = response.chat_room_mute;
	ChatRoom.applyMuteFromServer(chatRoomId, mute);
};
ServerMessageController.prototype.chat_room_read = function(response) {
	const { chat_room_id: chatRoomId, last_read_message_id: lastReadMessageId } = response.chat_room_read;
	ChatRoom.applyReadFromServer(chatRoomId, lastReadMessageId);
};
ServerMessageController.prototype.muted_from_chat = function(response) {
	const { muted_from_chat: mutedFromChat } = response;
	if(mutedFromChat.until) {
		mutedFromChat.until = DateFormat.momentFromLadderTime(mutedFromChat.until);
	}
	if(mutedFromChat.id) {
		const userChatRoom = myUser.chat_rooms.retrieve(mutedFromChat.id);
		userChatRoom.update({
			muted: mutedFromChat.until
		});
	}
	else {
		myUser.update({
			is_muted: mutedFromChat.until
		});
	}
	if(mutedFromChat.until) {
		ChatActions.addNotificationToChat(null, `You've been muted 
		${response.muted_from_chat.id ? `in ${response.muted_from_chat.name}` : 'from chatting'} for 
			${mutedFromChat.until.toNow(true)} 
			${(response.muted_from_chat.reason) ? ` Reason: ${response.muted_from_chat.reason}` : ''}`);
	}
	else {
		ChatActions.addNotificationToChat(null, `You've been unmuted 
			${response.muted_from_chat.id ? `in ${response.muted_from_chat.name}` : ''}`);
	}
};

ServerMessageController.prototype.rpg = function(response) {
	let rpg = response.rpg;

	const rpgMessage = new RpgMessage(rpg);
	const notification = rpgMessage.createNotification();
	ChatActions.addNotificationToChat(null, notification);

	function createRpgMessage(attack, message) {
		let messageContainer = $('<span>');
		if(attack.attacker.hit_points == 0) {
			let deadId = 'dead_message_' + attack.attacker.player.id;
			let deadMessage = $('#' + deadId);
			if(deadMessage.length) {
				deadMessage.text(message);
				return null;
			}
			else {
			}
			messageContainer.attr('id', deadId);
			messageContainer.addClass('is_dead');
		}
		else {
			messageContainer.removeClass('is_dead');
		}
		messageContainer.addClass('rpg_message');
		messageContainer.append(message);
		return messageContainer;
	}
};
ServerMessageController.prototype.chat_rooms = function(response, messageType) {
	applyChatRooms(response, messageType === Request.FROM_WEBSOCKET);
};
ServerMessageController.prototype.private_chat = function(response) {
	store.dispatch(notificationActions.receivedDirectMessages(directMessagePushes(response.private_chat)));
	privateChatMessageHolder.parseInitialList(response.private_chat);
};

// Sent with each direct message: how many people the player has unread direct
// messages from (services\chat\read\DirectMessageReadCursor). The DM list only
// loads a page of conversations, so this count is the one the badges show.
ServerMessageController.prototype.unread_direct_conversation_count = function(response) {
	store.dispatch(privateChatActions.unreadPrivateMessagesChanged(Number(response.unread_direct_conversation_count) || 0));
};

// The player read a conversation in one of their sessions
// (services\chat\read\DirectMessageReadCursor::markRead).
ServerMessageController.prototype.direct_message_read = function(response) {
	const read = response.direct_message_read;
	if(!read) {
		return;
	}
	privateChatMessageHolder.markConversationRead(read.other_player_id);
	store.dispatch(directMessageRead(read));
};

ServerMessageController.prototype.userChanges = function(response) {
	_.each(response.userChanges, function(user) {
		Users.update(user);
	});
};
ServerMessageController.prototype.chat_events = function(response) {
	if(response.chat_events) {
		var events = response.chat_events;
		if(events.invited) {
			$.each(events.invited, function(chatId, event) {
				var chat = event.chat;
				var invitee = Users.update(event.by);

				var container = $('<span>');
				var usernameElement = invitee.createUsernameElement();
				var chatElement = $('<span>').addClass('chatlink').text('You\'ve been invited to ' + chat.name + ' by ').attr('data-id', chat.id);
				container.append(chatElement).append(usernameElement);
				ChatActions.addNotificationToChat(null, container);
			});
		}
	}
	/**
	 * Socket_Pusher::send_to_user($invite_player,array('chat_events'=>array('invited'=>array(
	 $chat->id=>array(
	 'chat'=>$chat->array_serialize(),
	 'by'=>$invite_player->array_serialize())
	 ))
	 )
	 */
};

ServerMessageController.prototype.ping_player = function(pingPlayerData) {
	if(!BrowserNotification.checkBrowserFocus() || IS_LOCALHOST) {
		console.log('Browser tab does not have focus, do not start a ping test');
		return;
	}
	var pingPlayer = pingPlayerData.ping_player;
	var peerToConnectTo = pingPlayer.peer_id;

	var peer = new Peer({ key: 'syic4as01jvvaemi' });
	var dataConnection = null;

	var isHost = false;
	var connectionEstablished = false;
	var otherUser = Users.retrieveById(pingPlayer.player_id);
	if(!otherUser) {
		return null;
	}
	if(!otherUser.peer) {
		otherUser.peer = {
			id: null,
			ping: new PingAverage()
		};
	}
	var destroyPeer = function() {
		console.trace('DESTRUCTION');
		peer.destroy();
	};
	otherUser.peer.id = pingPlayer.peer_id;
	peer.on('open', function(id) {
		console.log('my peer id', id);
		//Peer connections will be fire and forget since a long term connection should not be necessary
		if(!myUser.peer) {
			myUser.peer = {};
		}
		myUser.peer.id = id;

		if(pingPlayer.peer_id) {
			console.log('attempting connection to ', pingPlayer.peer_id);
			dataConnection = peer.connect(pingPlayer.peer_id);
			isHost = false;
			dataConnectionEventBinder(dataConnection, otherUser);
			connectionEstablished = !!dataConnection;
			console.log(dataConnection);
			console.log(connectionEstablished);
		}
		else {
			peer.on('connection', function(conn) {
				dataConnection = conn;
				console.log('CONNECTION ESTABLISHED');
				otherUser.peer.id = dataConnection.peer;
				isHost = true;
				dataConnectionEventBinder(dataConnection, otherUser);
			});
			$.post(siteUrl + '/matchmaking/ping_player', {
				peer_id: myUser.peer.id,
				player_id: pingPlayer.player_id
			}, function(response) {
				if(!response.success) {
					destroyPeer();
					throw 'Error establishing user to connect to';
				}
				else {
					console.log('Success, it should only be a matter of time now...');
				}
			});
			//We're just going to wait for a connection
		}
		setTimeout(function() {
			//After a while, if no dataconnection is bound, we'll kill this to prevent a memory leak
			if(dataConnection) {
				return;
			}
			destroyPeer();
		}, 10000);

		//Since we were requested to connect to the peer, we'll request a connection to the other browser
	});
	peer.on('error', function(err) {
		console.log(':(');
		console.log(err);
		destroyPeer();
	});

	function dataConnectionEventBinder(dataConnection, otherUser) {
		if(!dataConnection) {
			destroyPeer();
			throw 'The peer data connection was not initialized';
		}
		else {
			console.log('');
			//peer.disconnect();
		}
		if(isHost) {
			var timeOutInterval = 1000;
			var sendPing = function() {
				console.log('sending PING');
				if(dataConnection && otherUser.peer && otherUser.peer.id) {
					var test = new PingTester();
					var measure = test.measure;
					dataConnection.send({
							type: 'ping',
							test: { uid: 1, id: measure.id, key: measure.key }
						}
					);
					setTimeout(sendPing, timeOutInterval);
				}
				else {
					destroyPeer();
					dataConnection = null;
				}
			};
			setTimeout(sendPing, 1000);
		}
		dataConnection.on('data', function(data) {
			console.log('Received', data);
			if(data.type == 'ping') {
				console.log('Sending PING');
				dataConnection.send({
					type: 'pong',
					reply: data.test
				});
			}
			if(data.type == 'pong') {
				if(data.reply) {
					if(PingTester.pingTests[data.reply.id]) {
						var result = PingTester.pingTests[data.reply.id].finished(data.reply);
						if(result !== null) {
							otherUser.peer.ping.add(result);
						}

						$('#ping_test_result').addClass('visible').find('.number').text(otherUser.peer.ping.getAverage());
					}
					else {
						console.log('Invalid reply', data.reply);
					}
				}
			}

		});
	}

	function PingMeasure(finishedCallback) {
		this.id = PingMeasure.currentId++;
		this.key = getRandomInt(1, 10000000);
		var that = this;
		var date = new Date();
		this.startTime = date.getTime();
		this.endTime = null;
		this.timedOut = false;
		this.totalTime = null;
		var finishPingMeasure = function() {
			finishedCallback();
			finishedCallback = null;
		};
		setTimeout(function() {
			if(!finishedCallback) {
				return;
			}
			that.timedOut = true;
			finishPingMeasure();
		}, 5000);
		this.reply = function() {

		};
		this.end = function() {
			var date = new Date();
			this.endTime = date.getTime();
			if(finishedCallback) {
				finishPingMeasure();
			}
			return that.totalTime = that.endTime - that.startTime;

		};
	}

	PingMeasure.currentId = 1;


	function PingTester(pingtestFinished) {
		var finishedCallback = function() {

		};
		var test = new PingMeasure(finishedCallback);
		this.measure = test;
		var tests = PingTester.pingTests;
		tests[test.id] = this;
		this.finished = function(reply) {
			if(reply.id == test.id && reply.key == test.key) {
				console.log(test);
				return test.end();
			}
			else {
				throw 'Error this test did not belong to this reply';
			}
		};
		finishedCallback = function() {
			pingtestFinished(test);
			delete PingTester.pingTests[test.id];
			return test;
		};
	}

	PingTester.pingTests = {};

};

export var ServerMessage = new ServerMessageController();
